"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _styledTools = require("styled-tools");
var _oxygenConstants = require("@8x8/oxygen-constants");
var _getBackgroundColor = _interopRequireDefault(require("./utils/getBackgroundColor"));
var _getDecoratorBorderRadius = _interopRequireDefault(require("./utils/getDecoratorBorderRadius"));
var _templateObject, _switchProp;
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
var InputWrapper = _styledComponents["default"].div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  background: ", ";\n  border-radius: ", ";\n  min-height: ", ";\n  display: flex;\n  margin: ", " 0;\n  min-width: ", ";\n  width: ", ";\n"])), _getBackgroundColor["default"], function (_ref) {
  var theme = _ref.theme,
    isSuffix = _ref.isSuffix,
    isPrefix = _ref.isPrefix;
  return (0, _getDecoratorBorderRadius["default"])(theme, isSuffix, isPrefix);
}, (0, _styledTools.switchProp)((0, _styledTools.prop)('size', [_oxygenConstants.inputSize["default"]]), (_switchProp = {}, _defineProperty(_switchProp, _oxygenConstants.inputSize.small, function (_ref2) {
  var theme = _ref2.theme;
  return theme.heightSmall;
}), _defineProperty(_switchProp, _oxygenConstants.inputSize["default"], function (_ref3) {
  var theme = _ref3.theme;
  return theme.height;
}), _defineProperty(_switchProp, _oxygenConstants.inputSize.large, function (_ref4) {
  var theme = _ref4.theme;
  return theme.heightLarge;
}), _switchProp)), function (_ref5) {
  var theme = _ref5.theme;
  return theme.verticalSpacing;
}, function (_ref6) {
  var theme = _ref6.theme;
  return theme.minWidth;
}, function (_ref7) {
  var fullWidth = _ref7.fullWidth,
    theme = _ref7.theme;
  return fullWidth ? '100%' : theme.width;
});
InputWrapper.displayName = 'InputWrapper';
var _default = InputWrapper;
exports["default"] = _default;